import { useQuasar } from "quasar";
import CancelPurchaseBillDialog from "src/modules/purchase-order/components/cancel-dialogs/CancelPurchaseBillDialog.vue";
import { notify } from "assets/scripts/utilities/api-clients";

export function useCancelPurchaseBill({ purchaseBill, formState, formData }) {
  const $q = useQuasar();

  const cancel = async () => {
    if (unref(purchaseBill)?.payment_requests?.length) {
      const activePaymentRequests = [];
      const processedPaymentRequests = [];

      unref(purchaseBill).payment_requests?.forEach((request) => {
        if (request.status_cd === "processed") {
          processedPaymentRequests.push(request.internal_number);
        } else if (
          request.status_cd !== "cancelled" &&
          request.status_cd !== "rejected"
        ) {
          activePaymentRequests.push(request.internal_number);
        }
      });

      if (processedPaymentRequests.length) {
        const message = `Payment has been processed against this purchase bill. Cancellation is no longer allowed. Processed Payment Requests are ${processedPaymentRequests.join(
          ", ",
        )}`;

        return notify({
          message,
          type: "negative",
        });
      }

      if (activePaymentRequests.length) {
        const message = `There are active payment requests against this purchase bill. Please connect to Accounts team for cancelling the payment request before cancelling this purchase bill. Active Payment Requests are ${activePaymentRequests.join(
          ", ",
        )}`;

        return notify({
          message,
          type: "negative",
        });
      }
    }

    if (unref(purchaseBill)?.invoices?.length) {
      const activeInvoices = [];

      unref(purchaseBill).invoices?.forEach((invc) =>
        activeInvoices.push(invc.number),
      );

      const message = `There are active invoices against this purchase bill. Please cancel invoices before cancelling this purchase bill. Active invoice(s) - ${activeInvoices.join(
        ", ",
      )}`;

      return notify({
        message,
        type: "negative",
      });
    }

    $q.dialog({
      component: CancelPurchaseBillDialog,
    });
  };

  const cancelButton = computed(() => {
    if (unref(formState)?.view) {
      return {
        label: "Cancel",
        color: "error-70",
        flat: true,
        fluid: true,
        dense: true,
        class: "q-px-xxs q-my-xs",
        align: "left",
        disable: unref(formData).status_cd == "cancelled",
        onClick: () => cancel(),
      };
    }

    return {};
  });

  return {
    cancelButton,
  };
}
